import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack,
} from '@mui/material';
import { SelectAddressComponent } from '../hooks/useForm';
import { useTranslation } from 'react-i18next';

const MultipleAddressesSelector = ({
  open,
  onClose,
  value,
  onChange,
  defaultAddress,
  recipient,
}) => {
  const { t } = useTranslation('translation');
  const [tempAddress, setTempAddress] = useState(value || {});

  const handleSave = () => {
    onChange(tempAddress);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">
            {t('donations.change-address')} - {recipient?.name}
          </Typography>

          <Button variant="text" onClick={() => setTempAddress(defaultAddress)}>
            {t('donations.set-default-address')}
          </Button>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {t('donations.default-address')}: {recipient?.formatted_address}
          </Typography>
        </Box>

        <SelectAddressComponent
          value={tempAddress}
          onChange={setTempAddress}
          label={t('donations.select-custom-address')}
          width="100%"
          height="400px"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel}>{t('common.cancel')}</Button>
        <Button variant="contained" onClick={handleSave}>
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MultipleAddressesSelector;
